<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-row>
      <el-form-item>
        <el-select-tree
          lazy
          class="select-tree"
          :props="props"
          checkStrictly
          value-key="uuid"
          node-key="uuid"
          v-model="filters.deptId"
          placeholder="工作单位"
          :load="loadNode"
        ></el-select-tree>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.leaderType"
          placeholder="管理主体"
        >
          <el-option
            v-for="(item, i) in leaderTypeData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-cascader
          ref="trainType"
          class="select_btn_style"
          v-model="filters.trainType"
          :options="trainTypeData"
          :props="propsType"
          collapse-tags
          placeholder="培训类型"
        >
        </el-cascader>
        <!--<el-select
          class="select_btn_style"
          v-model="filters.trainType"
          placeholder="培训类型"
        >
          <el-option
            v-for="(item, i) in trainTypeData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>-->
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.userStatus"
          placeholder="用户状态"
        >
          <el-option
            v-for="(item, i) in userStatusData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.isExam"
          placeholder="考核状态"
        >
          <el-option
            v-for="(item, i) in publicData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-show="!showMore" class="m-l-14">
        <butn btntype="primary" title="查询" @click="initData"></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
        <butn
          title="展开"
          iconName="el-icon-arrow-down"
          @click="showMore = true"
          class="czButn"
        ></butn>
      </el-form-item>
    </el-row>

    <el-row v-show="showMore">
      <el-form-item label="出生年月：">
        <el-date-picker
          class="date-picker"
          value-format="yyyy-MM-dd"
          size="small"
          v-model="filters.birthTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          unlink-panels
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="开班时间：">
        <el-date-picker
          class="date-picker"
          value-format="yyyy-MM-dd"
          size="small"
          v-model="filters.classBeginTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          unlink-panels
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间：">
        <el-date-picker
          class="date-picker"
          value-format="yyyy-MM-dd"
          size="small"
          v-model="filters.classEndTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          unlink-panels
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="班级学制：" class="m-l-14">
        <input
          class="credit-input"
          v-model="filters.trainDaysStart"
          v-enter-number
        /><span class="sepertor">至</span
        ><input
          class="credit-input"
          v-model="filters.trainDaysEnd"
          v-enter-number
        />
      </el-form-item>
      <el-form-item label="合计天数：" class="m-l-14">
        <input
          class="credit-input"
          v-model="filters.totalDaysStart"
          v-enter-number
        /><span class="sepertor">至</span
        ><input
          class="credit-input"
          v-model="filters.totalDaysEnd"
          v-enter-number
        />
      </el-form-item>

      <el-form-item class="m-l-14">
        <butn btntype="primary" title="查询" @click="initData"></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
        <butn
          title="收起"
          iconName="el-icon-arrow-up"
          @click="showMore = false"
          class="czButn"
        ></butn>
      </el-form-item>
    </el-row>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
import { deptTreeNew } from "@/api/dept";
import ElSelectTree from "el-select-tree";
import {
  treeChildVos,
} from "@/api/classOffline";
export default {
  components: { butn, ElSelectTree },
  data() {
    return {
      filters: {},
      deptTreeList: [],
      leaderTypeData: [],
      trainTypeData: [],
      userStatusData: [],
      publicData: [],
      showMore: false,
      props: {
        //树形
        label: "deptName",
        value: "uuid",
        isLeaf: function(data, node) {
          return !data.hasChildren
        }
      },
      propsType: {
        //树形
        multiple: false,
        value: "key",
        label: "name",
        children: "children",
        // checkStrictly: true,
      },
    };
  },
  created() {
    this.getTrainTypeList();
    this.getSysParamByTypes(["USER_LEADER_TYPE", "USER_STATUS", "IS_VALID"]);
  },
  methods: {
    // 加载节点
    loadNode(node, resolve) {
      if (node.level === 0) {
        setTimeout(() => {
          deptTreeNew().then((res) => {
            return resolve(res.data);
          });
        }, 300);
      }
      if (node.level >= 1) return this.getChildNode(node, resolve);
    },
    getChildNode(node, resolve) {
      setTimeout(() => {
        deptTreeNew({
          parentId: node.data.uuid || "",
        }).then((res) => {
          resolve(res.data);
        });
      }, 300);
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        res.data["USER_LEADER_TYPE"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        // res.data["CLASS_TYPE_DOWN"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        // res.data["CLASS_TYPE_UP"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["USER_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["IS_VALID"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.leaderTypeData = res.data["USER_LEADER_TYPE"];
        // let typeDownList = res.data["CLASS_TYPE_DOWN"];
        // this.trainTypeData = typeDownList.concat(res.data["CLASS_TYPE_UP"]);
        this.userStatusData = res.data["USER_STATUS"];
        this.publicData = res.data["IS_VALID"];
      });
    },
    getTrainTypeList() {
      treeChildVos({ type: "CLASS_TYPE_DOWN" }).then((res) => {
        let goal = [];
        if (!res || res.code != 0) return;
        goal = res.data;
        this.trainTypeData = goal
      });
    },
    initData() {
      if (this.filters.trainDaysStart && this.filters.trainDaysEnd) {
        if (
          parseInt(this.filters.trainDaysStart) >
          parseInt(this.filters.trainDaysEnd)
        ) {
          this.$message({
            message: "请输入正确的班级学制区间",
            type: "warning",
          });
          return;
        }
      } else if (this.filters.totalDaysStart && this.filters.totalDaysEnd) {
        if (
          parseInt(this.filters.totalDaysStart) >
          parseInt(this.filters.totalDaysEnd)
        ) {
          this.$message({
            message: "请输入正确的合计天数区间",
            type: "warning",
          });
          return;
        }
      }
      let params = { ...this.filters };
      delete params.birthTime;
      delete params.classBeginTime;
      delete params.classEndTime;
      if (this.filters.birthTime) {
        params["birthDayStart"] = this.filters.birthTime[0];
        params["birthDayEnd"] = this.filters.birthTime[1];
      }
      if (this.filters.classBeginTime) {
        params["startTimeStart"] = this.filters.classBeginTime[0];
        params["startTimeEnd"] = this.filters.classBeginTime[1];
      }
      if (this.filters.classEndTime) {
        params["endTimeStart"] = this.filters.classEndTime[0];
        params["endTimeEnd"] = this.filters.classEndTime[1];
      }
      this.$emit("search", params);
    },
    resetData() {
      this.filters = {};
      this.$emit("search", {});
    },
  },
};
</script>

<style lang="scss" scoped>
$color: #d7dbe0;
$border-radius: 2px;
.serach-form {
  text-align: left;
  & /deep/ .none-margin-right {
    margin-right: 0;
  }
  & /deep/ .date-picker {
    width: 240px;
  }
  /deep/ .credit-input {
    width: 60px;
    border-radius: 2px;
    border: 1px solid #dcdfe6;
    height: 30px;
    color: #606266;
    outline: none;
    -webkit-appearance: none;
    background-color: #ffffff;
    background-image: none;
    padding: 0 10px;
    &:focus {
      border-color: #3a85ff;
    }
  }
  .sepertor {
    margin: 0 10px;
  }
}
</style>
